import axios from "../http";

class PersonnelPay {
  postPersonnelPayExcel(data) {
    const url = "/zwy/api/upload/operate/employee/cost/report";
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //项目列表
  getProjectList() {
    const url = "/zwy/api/project/list";
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 项目列表(根据仓库搜索)
  getProjectListByWarehouse(warehouseId) {
    const url = `/zwy/api/project/list/by/warehouse?warehouseId=${warehouseId}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //单条数据上传
  postSinglePay(data) {
    const url = "/zwy/api/emp/cost/save";
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //2B人员支出计算
  getCostCalculate(warehouseId, reportDate) {
    const url = `/zwy/api/emp/cost/calculate/tob?warehouseId=${warehouseId}&reportDate=${reportDate}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
}

export default PersonnelPay;
